<script>
    import { fly } from 'svelte/transition';

    // -- shown for the "talent" role, which is still under construction. The
    // -- full-screen backdrop sits over everything and blocks interaction, so
    // -- the user can't proceed into the session.
    export let active = false;
</script>

{#if active}
    <div id="backdrop">
        <div id="alertWrapper" transition:fly="{{ y: 50, duration: 500 }}">
            <div id='alertMessage'>
                <span>Talent recording is under construction</span>
            </div>
        </div>
    </div>
{/if}

<style>
    #backdrop {
        position: fixed;
        inset: 0;
        z-index: 9999;
        background: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(4px);
        -webkit-backdrop-filter: blur(4px);
        display: flex;
        align-items: center;
        justify-content: center;
    }

    #alertWrapper {
        z-index: 10000;
    }

    #alertMessage {
        font-family: "Helvetica", sans-serif;
        font-weight: 225;
        font-size: 17px;
        color: antiquewhite;
        background: #b8860bcc;
        padding: 0.8em 1.2em;
        border-radius: 10px;
        box-shadow: 0px 4px 12px rgba(0,0,0,0.3);
        margin: 0;
    }
</style>
